import { render } from "./Index.vue?vue&type=template&id=9831dcde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=9831dcde&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9831dcde"

export default script